export enum MarkedQuestionsTabs {
  DESCRIPTION = 'Description',
}
